import { AppAbility } from '@open-commerce/oc-authorization-policies';
import { AbilityContext } from './AccessControlContext';

type AccessControlContextProviderProps = {
  value: AppAbility;
  children: React.ReactNode;
};

export const AccessControlContextProvider = ({
  value,
  children,
}: AccessControlContextProviderProps) => (
  <AbilityContext.Provider value={value}>{children}</AbilityContext.Provider>
);
